import 'bootstrap';
window.bootstrap = require('bootstrap');

/**
 * Frontend users action handler scripts
 *
 * @since 1.0.0
 */
import './subscription.js';
import './billing.js';
import './license.js';
import './affiliate.js';
import './downloads.js';
import './account-settings.js';
import './auth.js';
import './email-subscription.js';
import './google-login.js';
import './support-search.js';
import './pricing.js';
import './nonce-updater.js';
import './invoice.js';
